(function($){
  /**
   * vue.jsのレンダリング制御
   * 通信せず、jsonはhtml内にレンダリングされている。
   * json型 html内 data-refine-/.+/
   * 使用箇所
   *  ・イベント日付変更時
   *  ・レストラン、shop絞込
   *
   */
  Vue.config.debug = true;
  OH.VueRenderer = function(targetElement, options){
    options = !!options ? options : {};

    var masterData = null;
    var defineData = options.define;
    var resultData = null;
    var vue = null;
    var watcherPreserver = {};
    var optionMethods = !!options.methods ? options.methods : {};

    var callbackFunction = null;
    var observer = (function(){
      var inp = document.createElement("input");
      inp.setAttribute("type", "hidden");
      inp.setAttribute("value", "{{modified}}");
      targetElement.appendChild(inp);

      return new OH.AttributeObserver(inp, "value");
    })();

    var filters = {
      id2name : function(value, masterProp, excepts, delimiter){
        excepts = (excepts == null) ? [] : (excepts instanceof Array) ? excepts : [excepts];
        delimiter = !delimiter ? ', ' : delimiter;
        if(!masterData || !masterData[masterProp]){
          return "";
        }
        if(!(value instanceof Array)){
          return masterData[masterProp][OH.idPrefix + value];
        }

        var sufficientValues = [];
        var targetMaster = masterData[masterProp];
        for(var i=0; i<targetMaster.seq.length; i++){
          if(value.indexOf(targetMaster.seq[i]) >= 0){
            sufficientValues.push(targetMaster.seq[i]);
          }
        }

        var result = [];
        for(var i=0; i<sufficientValues.length; i++){
          if(excepts.indexOf(sufficientValues[i]) >= 0){
            continue;
          }
          result.push(masterData[masterProp][OH.idPrefix + sufficientValues[i]]);
        }
        return result.join(delimiter);
      },
      jpcurrency : function(num){
        return String.fromCharCode(165) + String(num).replace( /(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
      },
      todate : function(str){
        return (str.slice(4,6) - 0) + "月" + (str.slice(6) - 0) + "日";
      },
      labeled : function(value, masterProp){
        if(!masterData || !masterData[masterProp]){
          return "";
        }
        var target = masterData[masterProp][OH.idPrefix + value];
        return !target ? "" : target.label !== undefined ? target.label : target;
      }
    };
    options.filters = !!options.filters ? options.filters : {};
    for(var name in options.filters){
      filters[name] = options.filters[name];
    }

    var cloneHash = function(original, removeKeys){
      var clone = JSON.parse(JSON.stringify(original));
      if(!!removeKeys){
        for(var i=0; i<removeKeys.length; i++){
          for(var p in clone){
            delete clone[p][removeKeys[i]];
          }
        }
      }
      return clone;
    };

    var initVue = function(){
        for(var n in filters){
          Vue.filter(n, filters[n]);
        }
        
        vue = new Vue({
        el : targetElement,
        data : {
          // active: 'とりあえず',
          active: true,
          modified : new Date().getTime(),
          master : cloneHash(masterData, ["seq", "join"]),
          define : defineData,
          // list : resultData,
          list : [],
          model : options.model
        },
        methods : optionMethods
      });
    };
    var setWatcher = function(){
      for(var modelExp in watcherPreserver){
        vue.$watch(modelExp, watcherPreserver[modelExp]);
      }
    };

    this.init = function(json, callback){
      masterData = (!json || !json.define) ? {} : json.define;
      resultData = (!json || !json.result) ? {} : json.result;
      initVue();
      setWatcher();
      if(!!callback && (typeof callback === "function")){
        callback();
      }
    };

    this.addFilter = function(id, func){
      Vue.filter(id, func);
    }

    this.setWatcher = function(exp, func){
      if(!!vue){
        vue.$watch("model." + exp, func);
      }
      else{
        watcherPreserver["model." + exp] = func;
      }
    };

    this.getMaster = function(){
      return !!masterData ? masterData : {};
    }

    this.getModel = function(){
      return vue.$data.model;
    };
    this.getActive = function(bloon){
      vue.$data.active = bloon;
      return vue.$data.active;
    };

    this.setModel = function(dataPath, data){
      vue.$set("model." + dataPath, data);
    };

    this.getData = function(){
      return resultData;
    };

    this.setData = function(data){
      if(!!callbackFunction && typeof callbackFunction == "function"){
        observer.start(callbackFunction);
      }
      vue.$set("list", data);
      vue.$set("modified", new Date().getTime());
    };

    this.getObserver = function(){
      return observer;
    };

    this.setCallback = function(func){
      callbackFunction = func;
    };
  };

})(jQuery);
